import { createFileRoute } from '@tanstack/react-router';
import { ShipmentNewPage } from '../../features/shipments';

export const Route = createFileRoute('/portal/shipments/new')({ component: ShipmentNewPage });
